import { StockStatusEnum } from './stockStatusEnum.js';
export const sparkyLegacyStockStatusValidator = (hasItems) => {
    const fewLeftThreshhold = 1;
    if (hasItems > fewLeftThreshhold)
        return StockStatusEnum.InStock;
    if (hasItems === fewLeftThreshhold)
        return StockStatusEnum.FewLeftInStock;
    return StockStatusEnum.OutOfStock;
};
//# sourceMappingURL=sparkyLegacyStockStatusValidator.js.map